var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12.6 13.9",
    style: {
      enableBackground: "new 0 0 12.6 13.9"
    },
    xmlSpace: "preserve",
    width: 12.641,
    height: 13.934,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#555555;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,2.6H9.4V1.8c0-1-0.8-1.8-1.8-1.8H5C4,0,3.2,0.8,3.2,1.8v0.8H0.5C0.2,2.6,0,2.8,0,3.1s0.2,0.5,0.5,0.5 h0.8v8.6c0,1,0.8,1.8,1.8,1.8h6.5c1,0,1.8-0.8,1.8-1.8V3.6h0.8c0.3,0,0.5-0.2,0.5-0.5S12.4,2.6,12.1,2.6z M4.2,1.8 C4.2,1.4,4.6,1,5,1h2.6c0.4,0,0.8,0.4,0.8,0.8v0.8H4.2V1.8z M10.3,12.1c0,0.4-0.4,0.8-0.8,0.8H3.1c-0.4,0-0.8-0.4-0.8-0.8V3.6h8.1 V12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.7,6.1c-0.3,0-0.5,0.2-0.5,0.5v4.3c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5V6.6C5.2,6.3,5,6.1,4.7,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,6.1c-0.3,0-0.5,0.2-0.5,0.5v4.3c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5V6.6C8.5,6.3,8.2,6.1,8,6.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.cbe7444702e168c3494de6c002085d0c.svg";
export { ForwardRef as ReactComponent };